import type { BudgetFormModalProps } from '@/components/BudgetFormModal/BudgetFormModal.types'
import { Modal } from '@/components/Modal/Modal'

export function BudgetFormModal({
  children,
  onClose,
  opened,
}: BudgetFormModalProps) {
  return (
    <Modal centered onClose={onClose} opened={opened} withCloseButton={false}>
      {children}
    </Modal>
  )
}
